import { Box, Container } from '@mui/material';
import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useSettingsContext } from 'src/legacy/components/settings';
import { getCustomer } from 'src/legacy/redux/slices/customer';
import { useDispatch } from 'src/legacy/redux/store';
import { useActiveCompany } from 'src/organization/hooks/useActiveCompany';

import { BasicInfoCard } from './BasicInfoCard';
import { Breadcrumbs } from './Breadcrumbs';
import { CustomerDetailsNavigatorContextProvider } from './CustomerDetailsNavigatorContext';
import { Tabs } from './Tabs';

export const CustomerDetailsNavigator = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { themeStretch } = useSettingsContext();

  const { activeCompany } = useActiveCompany();

  useEffect(() => {
    if (activeCompany && id) {
      dispatch(getCustomer(activeCompany.id, Number(id)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCompany, id]);

  return (
    <CustomerDetailsNavigatorContextProvider>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <Breadcrumbs />

        <BasicInfoCard />

        <Tabs />

        <Box>
          <Outlet />
        </Box>
      </Container>
    </CustomerDetailsNavigatorContextProvider>
  );
};
